export const get_image = (type,id) => {
	return [process.env.REACT_APP_PHOTOSERVER_URL,process.env.REACT_APP_APPLICATION_NAME,type,id+".jpg"].join("/")
}

export const get_non_image = (lecture_id,filename) => {
	return [process.env.REACT_APP_PHOTOSERVER_URL,process.env.REACT_APP_APPLICATION_NAME,lecture_id,filename].join("/")
}